import React from "react";

export const sanitizers = {
  // Name fields: letters and single spaces only
  name: (value) => {
    if (!value) return '';
    return value
      .replace(/^\s+/, '')           // Remove leading spaces
      .replace(/\s{2,}/g, ' ')       // Replace multiple spaces with single space
      .replace(/[^a-zA-Z\s]/g, '');  // Only letters and spaces
  },

  // Phone: digits only, max 10
  phone: (value) => {
    if (!value) return '';
    return value
      .replace(/\D/g, '')            // Remove non-digits
      .slice(0, 10);                 // Max 10 digits
  },

  // Email: lowercase and trim
  email: (value) => {
    if (!value) return '';
    return value
      .toLowerCase()                 // Convert to lowercase
      .trim();                       // Remove leading/trailing spaces
  },

  // General text: allow all characters, don't trim during typing
  // Trimming should happen on form submission, not during user input
  text: (value) => {
    if (!value) return '';
    return value; // Return as-is, allow spaces
  },

  // Address field: allow alphanumeric, spaces, and common address characters
  address: (value) => {
    if (!value) return '';
    return value
      .replace(/^\s+/, '')           // Remove leading spaces
      .replace(/\s{2,}/g, ' ');      // Replace multiple consecutive spaces with single space
  }
};

// Hook for sanitized input handling
export const useSanitizedInput = (sanitizer, formik, fieldName) => {
  return React.useCallback((e) => {
    const sanitized = sanitizer(e.target.value);
    formik.setFieldValue(fieldName, sanitized);
  }, [sanitizer, formik, fieldName]);
};